import { Component } from '@angular/core';
import { ThemeService } from '@hyperkit';
@Component({
  standalone: false,
  selector: 'main-layout',
  templateUrl: 'main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  theme = 'light';
  constructor(
        private themeService: ThemeService,
  ) {
    this.theme = themeService.getTheme();
  }  
}
